import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
// New Revamped Public Pages
import HomePage from "./pages/HomePage";
import NewCertificationPage from "./pages/NewCertificationPage";
import FrameworkPage from "./pages/FrameworkPage";
import FounderPage from "./pages/FounderPage";
import NewPartnerProgramPage from "./pages/NewPartnerProgramPage";
import GalleryPage from "./pages/GalleryPage";
import EnquiriesPage from "./pages/EnquiriesPage";
import ContactPage from "./pages/ContactPage";
import FAQsPage from "./pages/FAQsPage";
import ResourcesPage from "./pages/ResourcesPage";
import PublicDirectoryPage from "./pages/PublicDirectoryPage";
import WhyCNESSPage from "./pages/WhyCNESSPage";
import CertificationTiersPage from "./pages/CertificationTiersPage";
import SuccessStoriesPage from "./pages/SuccessStoriesPage";
import CommunityPage from "./pages/CommunityPage";
import FrameworkVerifyPage from "./pages/FrameworkVerifyPage";
import FrameworkDownloadSuccessPage from "./pages/FrameworkDownloadSuccessPage";
// Legacy/Admin Pages (keeping functional)
import LandingPage from "./components/LandingPage";
import AboutPage from "./pages/AboutPage";
import CertificationPage from "./pages/CertificationPage";
import PillarsPage from "./pages/PillarsPage";
import MentorPartnerPage from "./pages/MentorPartnerPage";
import SupportPage from "./pages/SupportPage";
import SignupPage from "./pages/SignupPage";
import PricingPage from "./pages/PricingPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import EventsPage from "./pages/EventsPage";
import MediaKitPage from "./pages/MediaKitPage";
import NewsletterPage from "./pages/NewsletterPage";
import NewsPage from "./pages/NewsPage";
import PressPage from "./pages/PressPage";
import MentorApplicationPage from "./pages/MentorApplicationPage";
import PartnerApplicationPage from "./pages/PartnerApplicationPage";
import LoginPage from "./pages/LoginPage";
import PlatformApp from "./pages/PlatformApp";
import SystemAdminDashboard from "./pages/SystemAdminDashboard";
import LearningModulesPage from "./pages/LearningModulesPage";
import MyProgressPage from "./pages/MyProgressPage";
import AssessmentManagement from "./pages/AssessmentManagement";
import SystemConfig from "./pages/SystemConfig";
import Analytics from "./pages/Analytics";
import Reports from "./pages/Reports";
import Marketplace from "./pages/Marketplace";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import OrgAdminAssessmentDashboard from "./pages/OrgAdminAssessmentDashboard";
import QualitativeAssessmentPage from "./pages/QualitativeAssessmentPage";
import EnhancedAssessmentPage from "./pages/EnhancedAssessmentPage";
import PaymentPage from "./pages/PaymentPage";
import QuantitativeAssessmentPage from "./pages/QuantitativeAssessmentPage";
import ResultsPage from "./pages/ResultsPage";
import LearnRedirect from "./pages/LearnRedirect";
import EvaluatorDashboard from "./pages/EvaluatorDashboard";
import EvaluatorScoringPage from "./pages/EvaluatorScoringPage";
import EvaluatorAssessmentPage from "./pages/EvaluatorAssessmentPage";
import EvaluatorManagement from "./pages/EvaluatorManagement";
import EvaluatorProfile from "./pages/EvaluatorProfile";
import SuperAdminMonitoring from "./pages/SuperAdminMonitoring";
import UserManagement from "./pages/UserManagement";
import OrganizationDetails from "./pages/OrganizationDetails";
import MentorDashboard from "./pages/MentorDashboard";
import PartnerDashboard from "./pages/PartnerDashboard";
import ApprovalHub from "./pages/ApprovalHub";
import BestPracticesManagement from "./pages/BestPracticesManagement";
import DirectoryPage from "./pages/DirectoryPage";
import IndustriesManagement from "./pages/IndustriesManagement";
import AdminDirectoryPage from "./pages/AdminDirectoryPage";
import OrganizationTypesManagement from "./pages/OrganizationTypesManagement";
import QuestionSelectionPage from "./pages/QuestionSelectionPage";
import PartnerProgramPage from "./pages/PartnerProgramPage";
import PartnerManagement from "./pages/PartnerManagement";
import PartnerPortalDashboard from "./pages/PartnerPortalDashboard";
import PartnershipTypesManagement from "./pages/PartnershipTypesManagement";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* NEW REVAMPED PUBLIC PAGES */}
            <Route path="/learn" element={<LearnRedirect />} />
            <Route path="/learn/course/:courseId" element={<LearnRedirect target="course" />} />
            <Route path="/learn/organization" element={<LearnRedirect />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/certification" element={<NewCertificationPage />} />
            <Route path="/framework" element={<FrameworkPage />} />
            <Route path="/pillars" element={<FrameworkPage />} />
            <Route path="/founder" element={<FounderPage />} />
            <Route path="/about" element={<FounderPage />} />
            <Route path="/partner-program" element={<NewPartnerProgramPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/enquiries" element={<EnquiriesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faqs" element={<FAQsPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/why-cness" element={<WhyCNESSPage />} />
            <Route path="/certification-tiers" element={<CertificationTiersPage />} />
            
            {/* Legacy routes - redirecting to new pages */}
            <Route path="/old-landing" element={<LandingPage />} />
            <Route path="/old-certification" element={<CertificationPage />} />
            <Route path="/old-pillars" element={<PillarsPage />} />
            <Route path="/old-about" element={<AboutPage />} />
            
            {/* Functional Pages */}
            <Route path="/support" element={<SupportPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/media-kit" element={<MediaKitPage />} />
            <Route path="/newsletter" element={<NewsletterPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/press" element={<PressPage />} />
            <Route path="/partner-application" element={<PartnerApplicationPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/platform" element={<PlatformApp />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/marketplace/product/:productId" element={<ProductDetailPage />} />
            <Route path="/marketplace/cart" element={<CartPage />} />
            <Route path="/directory" element={<PublicDirectoryPage />} />
            <Route path="/old-directory" element={<DirectoryPage />} />
            
            {/* Admin Routes */}
            <Route path="/system-admin" element={<SystemAdminDashboard />} />
            <Route path="/assessment-management" element={<AssessmentManagement />} />
            <Route path="/admin/assessment-monitoring" element={<SuperAdminMonitoring />} />
            <Route path="/admin/user-management" element={<UserManagement />} />
            <Route path="/admin/approval-hub" element={<ApprovalHub />} />
            <Route path="/admin/best-practices" element={<BestPracticesManagement />} />
            <Route path="/admin/industries" element={<IndustriesManagement />} />
            <Route path="/admin/organization-types" element={<OrganizationTypesManagement />} />
            <Route path="/admin/question-selection" element={<QuestionSelectionPage />} />
            <Route path="/admin/directory" element={<AdminDirectoryPage />} />
            <Route path="/admin/partners" element={<PartnerManagement />} />
            <Route path="/admin/partnership-types" element={<PartnershipTypesManagement />} />
            <Route path="/admin/evaluator-management" element={<EvaluatorManagement />} />
            <Route path="/system-config" element={<SystemConfig />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/admin/org-details/:orgId" element={<OrganizationDetails />} />
            
            {/* Organization Assessment Routes */}
            <Route path="/org-admin/assessments" element={<OrgAdminAssessmentDashboard />} />
            <Route path="/org-assessment/qualitative/:assessmentId" element={<QualitativeAssessmentPage />} />
            <Route path="/org-assessment/enhanced/:assessmentId" element={<EnhancedAssessmentPage />} />
            <Route path="/org-assessment/payment/:assessmentId" element={<PaymentPage />} />
            <Route path="/org-assessment/quantitative/:assessmentId" element={<QuantitativeAssessmentPage />} />
            <Route path="/org-assessment/results/:assessmentId" element={<ResultsPage />} />
            
            {/* Evaluator Routes */}
            <Route path="/evaluator/dashboard" element={<EvaluatorDashboard />} />
            <Route path="/evaluator/organizations" element={<EvaluatorDashboard />} />
            <Route path="/evaluator/assess/:organizationId" element={<EvaluatorAssessmentPage />} />
            <Route path="/evaluator/score/:assessmentId/:organizationId" element={<EvaluatorScoringPage />} />
            <Route path="/evaluator/profile" element={<EvaluatorProfile />} />
            
            {/* Mentor/Partner Routes */}
            <Route path="/mentor/dashboard" element={<MentorDashboard />} />
            <Route path="/partner/dashboard" element={<PartnerDashboard />} />
            <Route path="/partner/portal" element={<PartnerPortalDashboard />} />
            
            {/* Learning Routes */}
            <Route path="/learning-modules" element={<LearningModulesPage />} />
            <Route path="/my-progress" element={<MyProgressPage />} />
            
            {/* App Routes */}
            <Route path="/app/*" element={<PlatformApp />} />
            
            {/* Resource Pages */}
            <Route path="/success-stories" element={<SuccessStoriesPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/framework-download/verify" element={<FrameworkVerifyPage />} />
            <Route path="/framework-download/success" element={<FrameworkDownloadSuccessPage />} />
            <Route path="/partner-resources" element={<ResourcesPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;